module.exports = __webpack_public_path__ + "img/show12.ae7da67a.png";